module.exports = __webpack_public_path__ + "img/dz_epic.662c6113.png";